import React, { useEffect, useRef, createRef, forwardRef, useState } from "react";

import { cachedFetchJson } from "../../helpers/fetch.js";

/* Props:
  title: '', <String> Content of the tooltip, may include HTML if options: {html: true} is provided
  options: {}, <Object> Options to be passed for jQuery tooltip (see jquery tooltip doc)
  trigger: 'hover', <String> ['hover'|'click'|'manual'] What event should trigger the tooltip
  className: '', // Additional classes to be added to container
  children: null, // Component that will be wrapped
  style: {}, // Additional styles for the wrapper
*/

// Wrapper component to provide tooltip for its children.
const Tooltip = ({ title = '', trigger ='hover', children, className = '', style = {}, options = {}, active = true, onClick }, ref) => {
 
  const innerRef = ref ? ref : useRef(null);
  const tooltipRef = useRef(null);

  const initTooltip = () => {
    if (innerRef.current) {
      if (active) {
        tooltipRef.current = jQuery(innerRef.current);
        jQuery(innerRef.current).tooltip({ trigger: trigger, ...options });
      } else {
        jQuery(innerRef.current).tooltip("destroy");
      }
    }

    return () => {
      if (tooltipRef.current) jQuery(tooltipRef.current).tooltip("destroy");
    }
  };

  useEffect(initTooltip, []);

  return (
    <div
      ref={innerRef}
      data-original-title={title}
      data-container="body"
      className={className}
      style={Object.assign({ display: "inline-block" }, style)}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
const TooltipWithRef = forwardRef(Tooltip);
export default TooltipWithRef;


// Load tooltip content from given dataUrl, expects a json {content: 'string for tooltip'}
export const TooltipWithAsyncContent = ({dataUrl, tooltipProps, children}) => {
  const [content, setContent] = useState(null);
  const tooltipRef = createRef();


  const fetchContent = () => {
    if (!content && dataUrl) {
      cachedFetchJson(dataUrl).then(res => setContent(res.content));
    }
  }
    
  useEffect( () => {
    jQuery(tooltipRef.current).on('show.bs.tooltip', fetchContent);
    return () => { jQuery(tooltipRef.current).off('show.bs.tooltip')}
  }, []);

  if (dataUrl == null) {
    return children;
  }

  return <TooltipWithRef
    key={content ? content : 'empty'}
    {...tooltipProps}
    title={content ? content : '...'}
    ref={tooltipRef}
    >
    {children}
  </TooltipWithRef>
}